import { Check, Crown } from "lucide-react";

const PLANS = [
  {
    id: "Demo",
    price: "₹0",
    period: "/week",
    tagline: "Try risk-free",
    features: [
      "Social media management",
      "4 posts/month",
      "Basic analytics",
      "10+ leads/week",
    ],
    cta: "Choose Plan",
    popular: false,
  },
  {
    id: "Advanced",
    price: "₹999",
    period: "/week",
    tagline: "For growing brands",
    features: [
      "Social media + ads",
      "20 posts/month",
      "Ad management",
      "Monthly reports",
      "20+ leads/week",
    ],
    cta: "Choose Plan",
    popular: true,
  },
  {
    id: "Pro",
    price: "₹1,648",
    period: "/week",
    tagline: "Full marketing team",
    features: [
      "Full marketing solution",
      "Unlimited creatives",
      "Ads + SEO",
      "Priority support",
      "Unlimited leads/week",
    ],
    cta: "Get Started",
    popular: false,
  },
];

export default function Pricing({ onChoose }) {
  return (
    <section id="pricing" className="relative py-14 md:py-20" data-testid="pricing-section">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 mx-auto h-40 max-w-3xl bg-blue-600/10 blur-3xl"
        aria-hidden
      />
      <div className="relative mx-auto max-w-6xl px-5 md:px-6">
        <div className="mb-10 text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-blue-400">
            Transparent pricing
          </span>
          <h2 className="mt-2 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Simple Pricing
          </h2>
          <p className="mx-auto mt-2 max-w-md text-sm text-slate-400">
            No hidden fees. Cancel anytime. Switch plans as you grow.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:items-stretch">
          {PLANS.map((plan, i) => {
            const isPopular = plan.popular;
            return (
              <div
                key={plan.id}
                className={`relative flex flex-col rounded-2xl p-6 animate-fade-up
                  ${isPopular
                    ? "border border-blue-500/60 bg-gradient-to-b from-blue-600/10 to-indigo-600/5 shadow-[0_30px_80px_-30px_rgba(37,99,235,0.6)] md:-translate-y-3 md:scale-[1.03]"
                    : "glass card-hover"
                  }`}
                style={{ animationDelay: `${0.08 * i}s` }}
                data-testid={`pricing-card-${plan.id.toLowerCase()}`}
              >
                {isPopular && (
                  <div
                    className="popular-ribbon absolute -top-3 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-white"
                    data-testid="pricing-popular-badge"
                  >
                    <Crown className="h-3 w-3" /> Most Popular
                  </div>
                )}

                <div className="mb-5">
                  <h3 className="font-display text-xl font-bold text-white">{plan.id}</h3>
                  <p className="mt-1 text-xs text-slate-400">{plan.tagline}</p>
                </div>

                <div className="mb-5 flex items-baseline gap-1">
                  <span className="font-display text-4xl font-extrabold text-white">
                    {plan.price}
                  </span>
                  <span className="text-sm text-slate-400">{plan.period}</span>
                </div>

                <ul className="mb-7 space-y-3 text-sm">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-slate-300">
                      <span
                        className={`mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full ${
                          isPopular ? "bg-blue-500/20 text-blue-300" : "bg-white/5 text-blue-400"
                        }`}
                      >
                        <Check className="h-3 w-3" />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>

                <button
                  type="button"
                  onClick={() => onChoose(plan.id)}
                  className={`mt-auto inline-flex h-11 items-center justify-center rounded-full text-sm font-semibold transition-all ${
                    isPopular
                      ? "btn-primary text-white"
                      : "btn-ghost text-white"
                  }`}
                  data-testid={`pricing-cta-${plan.id.toLowerCase()}`}
                >
                  {plan.cta}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
